
        require('./index.scss');
        "use strict";

var $ = window.$;

var _module = {
    init: function init() {}
};

_module.init();;
    


// WEBPACK FOOTER //
// ./src/module/home-index/header/header-links/index.js